var _g, _g2, _g3, _g4, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsage4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "mobile-payment_439146",
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.77,
    height: 31.77,
    viewBox: "0 0 31.77 31.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_161",
    "data-name": "Group 161",
    transform: "translate(5.341 2.909)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160",
    "data-name": "Group 160"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_136",
    "data-name": "Rectangle 136",
    width: 4.33,
    height: 1.887,
    fill: "#fcce11"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_163",
    "data-name": "Group 163",
    transform: "translate(7.853 26.973)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_162",
    "data-name": "Group 162"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_137",
    "data-name": "Rectangle 137",
    width: 2.936,
    height: 1.887,
    fill: "#fcce11"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_165",
    "data-name": "Group 165",
    transform: "translate(11.558 2.909)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_164",
    "data-name": "Group 164"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_138",
    "data-name": "Rectangle 138",
    width: 1.745,
    height: 1.887,
    fill: "#fcce11"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_167",
    "data-name": "Group 167"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_166",
    "data-name": "Group 166"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_609",
    "data-name": "Path 609",
    d: "M29.263,8.587H18.643V2.366A2.369,2.369,0,0,0,16.278,0H2.366A2.369,2.369,0,0,0,0,2.366V29.4A2.369,2.369,0,0,0,2.366,31.77H16.277A2.369,2.369,0,0,0,18.643,29.4V23.183h10.62a2.51,2.51,0,0,0,2.507-2.507V11.094A2.509,2.509,0,0,0,29.263,8.587ZM1.887,2.366a.479.479,0,0,1,.478-.478H16.277a.479.479,0,0,1,.478.478V5.819H1.887Zm0,5.34H16.756v.881h-1.89a2.51,2.51,0,0,0-2.507,2.507v9.582a2.51,2.51,0,0,0,2.507,2.507h1.89v.881H1.887Zm12.359,5.627H29.882v1.315H14.246Zm2.031,16.549H2.366a.479.479,0,0,1-.478-.478V25.951H16.756V29.4h0A.479.479,0,0,1,16.278,29.882ZM29.263,21.3h-14.4a.62.62,0,0,1-.619-.619V16.535H29.882v4.141h0A.62.62,0,0,1,29.263,21.3Zm.619-9.85H14.246v-.352a.62.62,0,0,1,.619-.619h14.4a.62.62,0,0,1,.619.619v.352Z",
    fill: "#fcce11"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_169",
    "data-name": "Group 169",
    transform: "translate(15.837 17.912)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_168",
    "data-name": "Group 168"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_139",
    "data-name": "Rectangle 139",
    width: 12.456,
    height: 1.887,
    fill: "#fcce11"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsage4);
export default __webpack_public_path__ + "static/media/usage-4.0d3d9515a4ea8a8dc7b7bb4bf976cb7d.svg";
export { ForwardRef as ReactComponent };